import { auth } from 'firebase'

export const googleAuthProvider = new auth.GoogleAuthProvider()
